// API endpoints and configuration constants

// Base configuration
export const API_CONFIG = {
  BASE_URL:
    import.meta.env.VITE_API_BASE_URL || "https://stch-api-dev.lumibot.com",
  TIMEOUT: 30000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
  CACHE_TIMEOUT: 5 * 60 * 1000,
};

// API endpoints based on the Django URL configuration
export const API_ENDPOINTS = {
  AUTH: {
    AUTHENTICATE: "/identities/authenticate/",
    MEMBER_MANAGEMENT: "/identities/member-management/",
    PUBLIC_MEMBER_LIST: "/identities/public-member-management/",
  },
  OPERATIONS: {
    SHIFTS: "/operations/shifts/",
    CREATE_SHIFT: "/operations/shifts/create/",
    SHIFT_DETAIL: (shiftId: string) => `/operations/shifts/${shiftId}/`,
    CHANGE_SHIFT_STATUS: (shiftId: string) =>
      `/operations/shifts/${shiftId}/change-status/`,
    LOCK_SHIFT_STATUS: (shiftId: string) =>
      `/operations/shifts/${shiftId}/lock-status/`,
    BARCODE_SCAN_HISTORY: "/operations/barcode-scan-history/",
    BULK_CREATE_SCANS: "/operations/barcode-scan-history/bulk-create/",
  },
  STCH: {
    RECORD_BITBOX_BLOCK: "/stch/bitbox-blocks/record/",
    LIST_BITBOX_BLOCKS: "/stch/bitbox-blocks/",
    BITBOX_REPORT: "/stch/bitbox-blocks/generate-report/", // NEW
  },
} as const;

// Request priorities for queue management
export const REQUEST_PRIORITY = {
  AUTH: 100,
  CRITICAL: 90,
  HIGH: 70,
  NORMAL: 50,
  LOW: 30,
  BACKGROUND: 10,
} as const;

// Cache keys
export const CACHE_KEYS = {
  AUTH_TOKEN: "api:auth:token",
  REFRESH_TOKEN: "api:auth:refresh",
  USER_DATA: "api:auth:user",
  SHIFTS: "api:operations:shifts",
  SCAN_HISTORY: "api:operations:scan_history",
  BITBOX_BLOCKS: "api:stch:bitbox_blocks",
  VERIFICATOR_MEMBERS: "api:identities:members",
} as const;

// Error messages
export const API_ERROR_MESSAGES = {
  NETWORK_ERROR:
    "Network connection failed. Please check your internet connection.",
  AUTHENTICATION_ERROR: "Authentication failed. Please log in again.",
  AUTHORIZATION_ERROR: "You do not have permission to perform this action.",
  SERVER_ERROR: "Server error occurred. Please try again later.",
  TIMEOUT_ERROR: "Request timed out. Please try again.",
  UNKNOWN_ERROR: "An unexpected error occurred. Please try again.",
} as const;

// HTTP status codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
} as const;
